import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import ProductDetailTag from './ProductDetailTag';

const PriceTag = props => {
  const wrapperClasses = classNames(props.className, {
    'price-tag--compact': props.compact,
  });

  const standardClasses = classNames('price-tag__standard', {
    'price-tag__standard--discounted': !!props.discountPrice,
    'price-tag__standard--auto-ship': props.autoShip && !props.discountPrice,
  });

  const discountClasses = classNames('price-tag__discount', {
    'price-tag__discount--auto-ship': props.autoShip,
  });

  return (
    <ProductDetailTag className={wrapperClasses}>
      {!!props.discountPrice && (
        <span className={discountClasses}>{props.discountPrice}</span>
      )}

      <span className={standardClasses}>{props.price}</span>
    </ProductDetailTag>
  );
};

PriceTag.propTypes = {
  autoShip: PropTypes.bool,
  className: PropTypes.string,
  compact: PropTypes.bool,
  discountPrice: PropTypes.element,
  price: PropTypes.element.isRequired,
};

export default PriceTag;
